import { EmployeeGradeEnum } from 'common/constants/enum';

const gradeOptions = [
  {
    id: EmployeeGradeEnum.A,
    label: EmployeeGradeEnum.A,
  },
  {
    id: EmployeeGradeEnum.B,
    label: EmployeeGradeEnum.B,
  },
  {
    id: EmployeeGradeEnum.C,
    label: EmployeeGradeEnum.C,
  },
  {
    id: EmployeeGradeEnum.D,
    label: EmployeeGradeEnum.D,
  },
  {
    id: EmployeeGradeEnum.E,
    label: EmployeeGradeEnum.E,
  },
  {
    id: EmployeeGradeEnum.F,
    label: EmployeeGradeEnum.F,
  },
];

export default gradeOptions;
